import { SessionItem } from "@/mds/components/sessions/session-item";
import { SessionEvent, SessionStatus } from "@/mds/components/sessions/session.types";

export interface MDSSessionEventsState {
  sessionEvents: SessionEvent[];
  sessionItems: SessionItem[];
  sessionStatus: SessionStatus;
  sessionItemToggleState: { [itemId: string]: boolean };
  sessionItemIdCache: { [partId: string]: string };
}

export enum MDSSessionEventsAction {
  UpsertSessionEvents = "UPSERT_SESSION_EVENTS",
  UpdateSessionStatus = "UPDATE_SESSION_STATUS",
  ToggleSessionItemExpandedState = "TOGGLE_SESSION_ITEM_EXPANDED_STATE",
}

export interface MDSSessionUpdateEventsAction {
  type: MDSSessionEventsAction.UpsertSessionEvents;
  payload: SessionEvent[];
}

export interface MDSSessionUpdateStatusAction {
  type: MDSSessionEventsAction.UpdateSessionStatus;
  payload: SessionStatus;
}

export interface MDSSessionToggleSessionItemExpandedStateAction {
  type: MDSSessionEventsAction.ToggleSessionItemExpandedState;
  payload: {
    itemId: string;
  };
}

export type MDSSessionEventsActionTypes =
  | MDSSessionUpdateEventsAction
  | MDSSessionUpdateStatusAction
  | MDSSessionToggleSessionItemExpandedStateAction;
